import { EnvObj } from 'src/main';

export const environment: EnvObj = {
  name: 'production',
  production: true,
  apiUrl: 'https://api.terlumina.com/api/',
  frontendDomain: 'terlumina.com',
  sentry_environment: 'production',
  sentry_enabled: true,
  shouldEnableProdMode: true,
  shouldEnableIntercom: true,
};
